import React from "react";
//#region types
import { TranslationKeys } from "translations";
import { SalaryPaymentListItem, SalaryPaymentListProps } from "models/propTypes/paymentPropTypes";
import { Amount } from "models/utilTypes/currencyType";
import { BankIdPaymentType } from "models/enums/payment";
import { CurrencyCode } from "models/enums/currency";
//#endregion
//#region components
import PaymentList from "../paymentListTable";
//#endregion
import cssExports from "theme/styles/main.module.scss";
import { LocalizationHelperInstance } from "utils/helpers";

const SalaryBankIdPaymentList: React.FC<SalaryPaymentListProps> = (props) => {
  return (
    <PaymentList
      properties={{
        personNumber: {
          description: TranslationKeys.Common.PersonNumber,
          formatter: (values: SalaryPaymentListItem) => values.item.personNumber,
          noWrap: true,
          maxWidth: 220,
        },
        accountNumber: {
          description: TranslationKeys.Settings.AccountNumber,
          formatter: (values: SalaryPaymentListItem) => values.item.bankAccount,
          noWrap: true,
          maxWidth: 130,
        },
        paymentDate: {
          formatter: (values: SalaryPaymentListItem) => new Date(values.item.payoutDate),
          description: TranslationKeys.Common.PayoutDate,
          noWrap: true,
        },
        amount: {
          formatter: (values: SalaryPaymentListItem) => new Amount(CurrencyCode.SEK, values.item.amount),
          description: TranslationKeys.Common.Amount,
          alignment: "right",
          className: cssExports.textBlack,
          noWrap: true,
        },
        group: {
          formatter: (values: SalaryPaymentListItem) => {
            return LocalizationHelperInstance.getFormattedMessage(
              values.type === BankIdPaymentType.ManualPayout
                ? TranslationKeys.Payments.Payments
                : TranslationKeys.Salary.Salaries
            );
          },
        },
      }}
      items={props.items ?? []}
      disableRowSelection={props.disableRowSelection}
      onRowSelectionsChange={props.onRowSelectionsChange}
      moreActions={props.moreActions}
    ></PaymentList>
  );
};

export default SalaryBankIdPaymentList;
